var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dropbox"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 2.66699L0 7.79907L8 12.8557L16 7.79907L8 2.66699ZM24 2.66699L16 7.79907L24 12.8557L32 7.79907L24 2.66699ZM0 17.9877L8 23.1198L16 17.9877L8 12.8557L0 17.9877ZM24 12.8557L16 17.9877L24 23.1198L32 17.9877L24 12.8557ZM8 24.7802L16 29.9123L24 24.7802L16 19.7236L8 24.7802Z",
    fill: "#0062FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropboxIcon);
export default __webpack_public_path__ + "static/media/dropbox-icon.bc6842902b5142756010216c5c983137.svg";
export { ForwardRef as ReactComponent };